import { motion } from "framer-motion";
import { projects } from "../data/portfolio";

export default function Projects() {
  return (
    <section id="projects" className="section">
      <div className="section-header">
        <span className="section-label">Research</span>
        <h2>Selected Projects</h2>
        <p className="section-desc">
          Highlights from diffractive optics, metasurfaces, graphene devices, and electromagnetic simulation work.
        </p>
      </div>

      <div className="projects-grid">
        {projects.map((project, i) => (
          <motion.a
            key={project.title}
            href={project.link}
            target="_blank"
            rel="noopener noreferrer"
            className="project-card"
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: i * 0.08, duration: 0.45 }}
          >
            <div className="project-image-wrap">
              <img src={project.image} alt={project.title} loading="lazy" />
            </div>
            <div className="project-body">
              <h3>{project.title}</h3>
              <p>{project.description}</p>
              <span className="project-link">Learn more →</span>
            </div>
          </motion.a>
        ))}
      </div>
    </section>
  );
}
